<template>
  <div class="stakeholders-table q-pa-lg bg-white-1 shadow3 border-radius-sm full-height">
    <AgGrid :options="options" :row-data="rowData" @ready="ready" @row-selected="selectRow">
      <template #header>
        <div class="text-body-4 text-secondary-1">Email will be sent to:</div>
      </template>
    </AgGrid>
  </div>
</template>

<script>
// Libraries
import { mapGetters } from 'vuex'
// Components
import AgGrid from '@/ag-grid/AgGrid'
import { checkboxCol } from '@/ag-grid/ag-columns'

export default {
  components: {
    AgGrid
  },

  props: {
    departments: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    agGrid: null,
    selectedRowsIds: []
  }),

  computed: {
    ...mapGetters('entity-labels', ['departmentLabel']),

    options() {
      return {
        columnDefs: [
          checkboxCol(),

          {
            headerName: 'Stakeholder',
            field: 'name',
            cellRenderer: params => {
              return `<b>${params.value}</b> (${params.data.email || 'no email'})`
            }
          },

          {
            headerName: this.departmentLabel.singular,
            field: 'department',
            cellRenderer: params => params.data.department.name || 'N/A'
          }
        ]
      }
    },

    rowData() {
      const rows = []

      this.departments.forEach(department => {
        const rowsIds = rows.map(row => row.id)

        department.stakeholders_with_stakes.forEach(({ id, name, email }) => {
          if (!rowsIds.includes(id)) {
            rows.push({ id, name, email, department: { id: department.id, name: department.name } })
          }
        })
      })

      return rows
    }
  },

  methods: {
    // access from parent
    getSelectedRowsIds() {
      return this.selectedRowsIds
    },

    ready(agGrid) {
      this.selectedRowsIds = []
      agGrid.api.selectAll()
      this.agGrid = agGrid
    },

    selectRow({ row, isSelected }) {
      if (isSelected) this.selectedRowsIds.push(row.id)
      else this.selectedRowsIds = this.selectedRowsIds.filter(subId => subId !== row.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

.stakeholders-table {
  @include table-with-no-filters;
}
</style>
